import { createApp } from 'vue'
import Message from './AppMessageCn.vue'

interface MessageOptions {
  message: string
  type?: 'success' | 'error' | 'info'
  duration?: number
}

declare interface MessageServiceCn {
  (options: MessageOptions | string): void
  success: (message: string, duration?: number) => void
  error: (message: string, duration?: number) => void
  info: (message: string, duration?: number) => void
}

let messageInstance: any = null

const MessageServiceCn = (options: MessageOptions | string) => {
  const ops = typeof options === 'string' ? { message: options } : options

  // 查找登录框内的消息容器
  // const loginContainer = document.querySelector('#login_cn_container .login-container')
  const loginContainer = document.querySelector('#app')
  if (!loginContainer) {
    console.warn('未找到登录框消息容器')
    return
  }

  // 创建容器
  const container = document.createElement('div')
  loginContainer?.appendChild(container)

  // 创建实例
  const app = createApp(Message, {
    ...ops,
    onClose: () => {
      app.unmount()
      loginContainer?.removeChild(container)
      messageInstance = null
    }
  })

  messageInstance = app.mount(container)

  return messageInstance
}

// 添加便捷方法
MessageServiceCn.success = (message: string, duration?: number) => {
  return MessageServiceCn({ message, type: 'success', duration })
}

MessageServiceCn.error = (message: string, duration?: number) => {
  return MessageServiceCn({ message, type: 'error', duration })
}

MessageServiceCn.info = (message: string, duration?: number) => {
  return MessageServiceCn({ message, type: 'info', duration })
}

export default MessageServiceCn
